import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
    { label: "The Story", target: "story" },
    { label: "About", target: "about" },
    { label: "Blog", target: "blog" },
    { label: "Epilogue", target: "epilogue" },
    { label: "Letters", target: "letters" },
    { label: "Pre-Order", target: "preorder" },
];

export default function TopNav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <header
            data-testid="top-nav"
            className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${
                scrolled || open
                    ? "border-b border-[rgba(212,175,55,0.18)] bg-[rgba(8,19,13,0.8)] backdrop-blur-xl"
                    : "border-b border-transparent bg-transparent"
            }`}
        >
            <nav className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
                <button
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    data-testid="nav-home"
                    className="font-cinzel text-sm tracking-[0.3em] text-[#f0d9a8] [text-shadow:0_2px_14px_rgba(0,0,0,0.9)]"
                >
                    EVE CAME FIRST
                </button>

                <div className="hidden items-center gap-7 lg:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.target}
                            onClick={() => go(l.target)}
                            data-testid={`nav-${l.target}`}
                            className="font-cinzel text-[0.65rem] tracking-[0.25em] text-[#d8c8a0] uppercase [text-shadow:0_2px_12px_rgba(0,0,0,0.9)] transition-colors duration-300 hover:text-[#f0d9a8]"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        onClick={() => go("remembering")}
                        data-testid="nav-join"
                        className="btn-eden rounded-full bg-gradient-to-br from-[rgba(160,120,60,0.9)] to-[rgba(120,85,40,0.9)] px-5 py-2.5 text-[0.6rem] text-[#f5e6c8]"
                    >
                        Join the Remembering
                    </button>
                </div>

                <button
                    className="text-[#d4af37] lg:hidden"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-menu-button"
                    aria-label="Open menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            {open && (
                <div
                    className="border-t border-[rgba(212,175,55,0.15)] bg-[rgba(8,19,13,0.94)] px-6 py-6 backdrop-blur-xl lg:hidden"
                    data-testid="nav-mobile-menu"
                >
                    <div className="flex flex-col gap-5">
                        {LINKS.map((l) => (
                            <button
                                key={l.target}
                                onClick={() => go(l.target)}
                                data-testid={`nav-mobile-${l.target}`}
                                className="font-cinzel text-left text-xs tracking-[0.3em] text-[#e8dcc0] uppercase"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            onClick={() => go("remembering")}
                            data-testid="nav-mobile-join"
                            className="font-cinzel text-left text-xs tracking-[0.3em] text-[#d4af37] uppercase"
                        >
                            Join the Remembering
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
